var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label"},[_c('Icon',{attrs:{"name":"check","group":"general","size":16,"inline":""}}),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }